<style>
  .table td {
  color: white !important;
}
</style>


@if (showSpinner) {
  <app-loader> </app-loader>
}
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="container-fluid mb-4">
    <div class="policy-main pb-3" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
      <h1 class="policy-heading">

        <i class="fa fa-arrow-circle-left" routerLink="/setting"></i>

        Setup Text Automation
      </h1>
      @if (isavailablefeature('add')) {
        <div class="btn btn-primary add-button" data-toggle="modal" data-target="#setuptextModal"
          > + Add Text for Automation
        </div>
      }
    </div>
    <div class="data-table">
      <div class="table-headings">
        <div class="row">
          <div class="col-2 table-head" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <h3> Title</h3>
          </div>
          <div class="col-8 table-head" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <h3>Automation Text</h3>
          </div>
          <div class="col-2 table-head action" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            @if (isavailablefeature('edit') || isavailablefeature('delete')) {
              <h3>Action</h3>
            }
          </div>
        </div>
      </div>

      @for (data of gettextauto; track data) {
        <div class="table-data-main">
          <div class="row data-row">
            <div class="col-2 table-head" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
              <h4>{{data.title}}</h4>
            </div>
            <div class="col-8 table-data description" [ngClass]="{ 'dark-descript': selectedMode === 'dark' }">
              <div>
                <h6>{{data.text}}</h6>
              </div>
            </div>
            @if (isavailablefeature('edit') || isavailablefeature('delete')) {
              <div class="col-2 table-data">
                <div class="row">
                  @if (isavailablefeature('edit')) {
                    <div class="col-6 icons">
                      <i class="fa fa-edit edit" (click)="editAutoText(data)"></i>
                    </div>
                  }
                  @if (isavailablefeature('delete')) {
                    <div class="col-6 icons">
                      <i class="fa fa-trash delete" data-toggle="modal" data-target="#deleteModal"
                      (click)="setDeleteId(data.id)"></i>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }


    </div>
  </div>

  <!-- add setup automation text modal -->
  <div class="modal fade" id="setuptextModal" #setuptextModal tabindex="-1" role="dialog"
    aria-labelledby="setuptextModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
        <div class="modal-header">
          <h5 class="modal-title" id="setuptextModalLabel">Add Text for Automation</h5>

        </div>
        <div class="modal-body">
          <form id="form-link-des" name="setuptext" #des="ngForm" (ngSubmit)="onSubmit(des)">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <input type="text" name="set_text" id="set_text" placeholder="Set Text*" class="form-control pl-2"
                    ngModel #set_text="ngModel" required />
                    <!-- <div class="warning" *ngIf="set_text.touched && set_text.invalid">
                    setup text is required.
                  </div> -->
                </div>
              </div>


              <div class="col-md-12">
                <div class="form-group">
                  <select id="types" name="types" class="form-control pl-1 selectpicker" [(ngModel)]="selectedData"
                    required>
                    <option value="null" disabled selected>Select Type</option>
                    @for (type of gettype; track type) {
                      <option [ngValue]="type">{{type.title}}</option>
                    }
                  </select>
                  <!-- <div class="warning" *ngIf="types.touched && types.invalid">
                  Type Selection is required.
                </div> -->
              </div>
            </div>


          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light" data-dismiss="modal">Cancel</button>
        <button type="submit" class="btn btn-primary" [disabled]="des.invalid" form="form-link-des">Save
        changes</button>
      </div>
    </div>
  </div>
</div>

<!-- Edit setup automation text modal -->
<div class="modal fade" id="edittextModal" #edittextModal tabindex="-1" role="dialog"
  aria-labelledby="edittextModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <div class="modal-header">
        <h5 class="modal-title" id="edittextModalLabel">Edit Text for Automation</h5>

      </div>
      <div class="modal-body">
        <form id="form-link-des1" name="setuptext" #des1="ngForm" (ngSubmit)="onEditSubmit(des1)">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <input type="text" name="set_text" id="set_text" placeholder="Set Text*" class="form-control pl-2"
                  ngModel #set_text="ngModel" [(ngModel)]="dataAutoTextforEdit.text" required />
                  <!-- <div class="warning" *ngIf="set_text.touched && set_text.invalid">
                  setup text is required.
                </div> -->
              </div>
            </div>


            <div class="col-md-12">
              <div class="form-group">
                <select id="types" name="types" class="form-control pl-1 selectpicker"
                  [(ngModel)]="dataAutoTextforEdit.typeid" required>
                  <option value="null" disabled selected>Select Type</option>
                  @for (type of gettype; track type) {
                    <option [ngValue]="type.id">{{type.title}}</option>
                  }
                </select>
                <!-- <div class="warning" *ngIf="types.touched && types.invalid">
                Type Selection is required.
              </div> -->
            </div>
          </div>


        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light" data-dismiss="modal">Cancel</button>
      <button type="submit" class="btn btn-primary" form="form-link-des1">Save
      </button>
    </div>
  </div>
</div>
</div>
<!-- Delete Modal -->
<div #deleteModal class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="deleteModalTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="deleteModalTitle">Are You Sure?</h3>
      </div>
      <div class="modal-body">
        <img src="../../../assets/images/question.jpg" alt="Missig Image">
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" (click)="deleteAutomationtext(selectedId)">Delete</button>
      </div>
    </div>
  </div>
</div>

</main>